<template>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-2">
            <label for="">{{ $t('devices.station') }}: </label>
            <el-select
              clearable
              filterable
              class="select-default custom-width-select mb-3 shadow-sm required-station"
              :placeholder="`${$t('common_words.select2')}...`"
              v-model="payload.station"
              value-key="id"
              @change="getSensors()"
            >
              <el-option
                class="select-default"
                v-for="(station, index) in stations"
                :key="index"
                :label="station.name"
                :value="station"
              >
              </el-option>
            </el-select>
          </div>
          <!-- <div class="col-1 text-right">
            <label for="" style="color:transparent">Todos</label>
            <el-checkbox
              label="Todos"
              v-model="payload.allSensors"
              @change="allSensors"
              class="select-secondary custom-width-select mt-2"
            >
            </el-checkbox>
          </div> -->
          <div class="col-3 pl-0 text-left">
            <label for="">{{ $t('devices.sensors') }}: </label>
            <el-select
              clearable
              v-bind:disabled="payload.allSensors"
              v-bind:collapse-tags="true"
              multiple
              class="select-primary custom-width-select bus-rels shadow-sm required-sensors"
              filterable
              v-model="payload.sensor_codes"
              :placeholder="$t('devices.select_sensors')"
              @change="
                selectAllFromSelectSensors('payload.sensor_codes', sensors)
              "
              value-key="id"
              @focus="sensorSelectTouched()"
            >
              <el-option
                v-for="(sensor, index) in sensors"
                class="select-primary selected-all"
                :value="sensor.code"
                :label="`${sensor.name}`"
                :key="index"
              >
              </el-option>
            </el-select>
          </div>

          <div class="col-12 col-sm-6 col-md-3">
            <label for="">{{ $t('common_words.date') }}: </label>
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm"
              :clearable="false"
              v-model="rangeDate"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="-"
              :start-placeholder="$t('common_words.initial_date')"
              :end-placeholder="$t('common_words.final_date')"
              :align="'right'"
            >
            </el-date-picker>
          </div>
          <div class="col-2">
            <label for="">{{ $t('common_words.frequency') }}: </label>
            <el-select
              clearable
              filterable
              class="select-default custom-width-select mb-3 shadow-sm"
              :placeholder="`${$t('common_words.select2')}...`"
              v-model="payload.frecuency"
            >
              <el-option
                class="select-default"
                v-for="(frecuency, index) in frecuencyList"
                :key="index"
                :label="frecuency.text"
                :value="frecuency.textSend"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-1">
            <label style="color: white">.</label><br />
            <button class="btn btn-info custom-shadow-btn" @click="validate()">
              {{ $t('common_words.filter') }}
            </button>
          </div>
        </div>
      </card>
      <div v-if="showReport">
        <card class="custom-shadow-card-header">
          <div class="row">
            <div class="col-12">
              <highcharts :options="chartOptions"></highcharts>
            </div>
          </div>
        </card>
        <card class="custom-shadow-card-header custom-table-responsive">
          <div class="mt-4">
            <div class="row" v-if="isIndex()">
              <div class="col-12 custom-flex">
                <el-select
                  class="select-default mb-3 shadow-sm"
                  style="width: 200px"
                  v-model="pagination.perPage"
                  :placeholder="$t('common_words.per_page')"
                  filterable
                >
                  <el-option
                    class="select-default"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12">
                <el-table :data="queriedData">
                  <el-table-column
                    :label="$t('common_words.period')"
                    prop="date"
                    min-width="150"
                  >
                  </el-table-column>
                  <el-table-column
                    v-for="(campo, indexField) in columns"
                    :key="indexField"
                    :label="campo.columnP + '-' + campo.unit"
                    :render-header="renderHeader"
                    min-width="150"
                  >
                    <el-table-column
                      v-for="(field, index) in campo.children_columns"
                      :key="index"
                      :label="field.label"
                      :prop="field.prop"
                      min-width="110"
                    >
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </div>
              <div
                slot="footer"
                class="my-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class>
                  <p class="card-category">
                    {{ $t('table2.showing') }} {{ from + 1 }}
                    {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                    {{ total }} {{ $t('table2.entries') }}
                  </p>
                </div>
                <l-pagination
                  class="pagination-no-border"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="pagination.total"
                  pageFirst="false"
                  pageLast="false"
                ></l-pagination>
              </div>
            </div>
            <div v-else>
              <br />
              <h5 class="text-muted text-center">
                {{ $t('common_words.no_permissions') }}
              </h5>
            </div>
          </div>
          <div class="row mb-4" style="padding-right: 13px; padding-left: 13px">
            <div class="col-6" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportPDF"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { Checkbox } from 'element-ui';
import { mapActions } from 'vuex';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import axios from 'axios';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinDinamicCharts from 'src/util/mixinDinamicCharts';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import paginationData from './paginationData';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
    [Checkbox.name]: Checkbox,
    highcharts: Chart,
  },

  computed: {
    ...paginationData.functions,

    frecuencyList() {
      return [
        { text: i18n.t('common_words.daily'), textSend: 'daily' },
        { text: i18n.t('common_words.weekly'), textSend: 'weekly' },
        { text: i18n.t('common_words.monthly'), textSend: 'monthly' },
        { text: i18n.t('common_words.annual'), textSend: 'annually' },
      ];
    },
  },

  data() {
    return {
      payload: {
        first: '',
        last: '',
        frecuency: 'daily',
        station: null,
        sensor_codes: [],
        sensor_names: [],
        allSensors: false,
      },
      pagination: paginationData.pagination,
      showReport: false,
      stations: [],
      sensors: [],
      tdata: [],
      columns: null,
      chartOptions: {},
      responseDataSerieBar: null,
      dates2: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDinamicCharts,
    MixinDatePicker,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': ['getChartLabels', 'getSelectAll', 'forceRerender'],
  },

  methods: {
    getSelectAll() {
      this.sensors = this.concatAll(this.sensors.splice(1));
    },
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    renderHeader(h, { column }) {
      return h('div', [
        h('span', column.label.split('-')[0]),
        h('br'),
        h('span', column.label.split('-')[1]),
      ]);
    },

    getChartLabels() {
      if (this.dates2) {
        this.chartOptions = this.spline(
          i18n.t('devices.sensor_report'),
          i18n.t('devices.by_station'),
          this.dates2,
          this.responseDataSerieBar
        );
      }
    },

    getTableData() {
      this.showHideLoading(true);
      axios
        .post('/makeReport/', {
          first: this.payload.first,
          last: this.payload.last,
          frecuency: this.payload.frecuency,
          station_code: this.payload.station.code_station,
          station_id: this.payload.station.id,
          sensor_codes: this.payload.sensor_codes,
          sensor_names: this.payload.sensor_names,
          allSensors: this.payload.allSensors,
        })
        .then((response) => {
          this.columns = response.data.tableData.columns;
          this.showReport =
            response.data.tableData.totalChildrenColumns > 0 ? true : false;
          this.tdata = response.data.tableData.data;

          if (this.tdata.length === 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            const dates = this.tdata.map((value) => {
              if (value['date']) return value['date'];
            });

            dates.sort((a, b) => new Date(b) - new Date(a));

            this.dates2 = dates;
            this.responseDataSerieBar = response.data.serie_bar;
            try {
              this.getChartLabels();
            } catch (error) {
              console.log('error: ', error);
            }
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(i18n.t('common_words.unavailable_data'));
        });
    },

    loadData() {
      return {
        first: this.payload.first,
        last: this.payload.last,
        frecuency: this.payload.frecuency,
        station_code: this.payload.station.code_station,
        station_id: this.payload.station.id,
        sensor_codes: this.payload.sensor_codes,
        sensor_names: this.payload.sensor_names,
        allSensors: this.payload.allSensors,
      };
    },

    exportPDF() {
      let data = this.loadData();
      data.route = 'climates/climatestationsdata/pdf';
      data.name_file = `${i18n.t('climate.station_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel() {
      let data = this.loadData();
      data.route = 'climates/climatestationsdata/excel';
      data.name_file = `${i18n.t('climate.station_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    getSensors() {
      this.payload.sensor_codes = [];
      axios
        .get(`/sensorsPerStation/${this.payload.station.id}`)
        .then((response) => {
          this.sensors = this.concatAllSensors(response.data);
        });
      // .catch(error => {
      //   SweetAlert.warning("Error al cargar sensores");
      // });
    },

    sensorSelectTouched() {
      // this.payload.allSensors = false;
    },

    sensorChange(sensor) {
      // const sensorCodes = [];
      // for (let i = 0; i < sensor.length; i++) {
      //   sensorCodes.push(sensor[i]["name"]);
      // }
      // this.payload.sensor_names = sensorCodes;
    },

    // allSensors(checked) {
    //   if (checked) {
    //     // this.payload.allSensors = true;
    //     this.payload.sensor_codes = [];
    //     this.payload.sensor_names = [];
    //   }
    // },

    validate() {
      if (this.payload.station == null) {
        return this.validationInputsRequired('station');
        // }
        // else if (
        //   !this.payload.allSensors &&
        //   (this.payload.sensor_codes.length == 0 ||
        //     this.payload.sensor_names.length == 0)
        // ) {
        //   return this.validationInputsRequired("sensors");
      } else {
        this.pagination.perPage = 10;
        this.pagination.currentPage = 1;
        this.getTableData();
      }
    },
  },
  created() {
    this.showHideLoading(true);
    Axios.getMasters('devices/stations')
      .then((response) => {
        this.stations = response.data.data;
        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
        SweetAlert.warning(error.response.data.message);
      });
  },
  updated() {
    if (this.rangeDate.length == 2) {
      let firstDate = new Date(this.rangeDate[0]);
      let lastDate = new Date(this.rangeDate[1]);
      if (firstDate > lastDate) {
        SweetAlert.warning(i18n.t('sweet_alert.climates.last_date_error'));
      } else {
        this.payload.first = firstDate.toString().split('(')[0].trim();
        this.payload.last = lastDate.toString().split('(')[0].trim();
      }
    }
  },

  mounted() {
    this.selectedItemOnMenu('climates');
  },

  destroyed() {
    this.deselectedItemOnMenu('climates');
  },
};
</script>
<style scoped>
.custom-flex {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
}
.my-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.my-custom-td-style {
  height: 55px;
  margin: 0px;
  width: 100%;
}
</style>
